
import jQuery from "jquery";

import '../plugins/jquery-ui.datepicker';

export default function initDatepicker() {

  jQuery('[data-range-datepickers]').each(function(){
    const holder = jQuery(this);
    const formInput = holder.find('.datepicker.from-datepicker');
    const toInput = holder.find('.datepicker.to-datepicker');
    const collapse = holder.closest('.collapse');
    const wrapper = holder.closest('.datepicker-holder');
    const opener =  wrapper.find('.btn-opener');

    document.addEventListener('click', function(e){
      if(!collapse.hasClass('show')) return;
      if (!e.target.closest('.collapse') && !e.target.closest('.ui-datepicker') && !e.target.closest('.ui-corner-all')) {
        opener.trigger('click');
      }
    })
    formInput.datepicker({
      defaultDate: 0,
      dateFormat: 'yy-mm-dd',
      showOtherMonths: true,
      changeMonth: true,
      changeYear: true,
      minDate: '+0d',
      onClose: function(selectedDate) {
        toInput.datepicker('option', 'minDate', selectedDate);
      }

    });
    toInput.datepicker({
      defaultDate: 1,
      dateFormat: 'yy-mm-dd',
      showOtherMonths: true,
      changeMonth: true,
      changeYear: true,
      minDate: '+0d',
      onClose: function(selectedDate) {
        formInput.datepicker('option', 'maxDate', selectedDate);
      }
    });
  })
}